import { APIMemberData } from "@companion-core/shared/app/Interfaces/API";
import { getModule } from "@companion-core/shared/app/Utils/config";
import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const usePreferences = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const isMemberFetching = useIsFetching({ queryKey: ["member"] });
  const data = queryClient.getQueryData(["member"]) as APIMemberData | null;
  const myAccountModule = getModule("my-account");

  return {
    t,
    isMemberFetching,
    data,
    myAccountModule,
  };
};
